import React from 'react';
import { useRouter } from 'next/router';

const Tag = ({ tagList, handleChange }) => {
  const { query: { tag } } = useRouter();

  const handleCategoryClick = (index) => {
    const categoryIndex = tag?.split(",")?.indexOf(index);
    if (categoryIndex !== undefined && categoryIndex > -1) {
      handleChange(tag?.split(",")?.filter((categoryIndex) => categoryIndex !== index))
    } else {
      if (tag) {
        handleChange([...tag.split(","), index])
      } else {
        handleChange([index])
      }
    }
  };

  return (
    <>
      {tagList?.map((category) => {
        const data = category.attributes;
        return (
          <li className='my-1 mr-2.5' key={data.post_tag_slug}>
            <button
              className={`group flex h-9 items-center rounded-lg ${
                tag?.split(",")?.includes(data.post_tag_slug)
                  ? 'border-accent dark:bg-accent text-white border'
                  : `border dark:border-jacarta-600 text-white`
              } px-4 font-display text-sm font-semibold transition-colors hover:border-transparent hover:bg-accent hover:text-white dark:text-white dark:hover:border-transparent dark:hover:bg-accent dark:hover:text-white`}
              onClick={() => handleCategoryClick(data.post_tag_slug)}
            >
              <span>{data.post_tag_name}</span>
            </button>
          </li>
        );
      })}
    </>
  );
};

export default Tag;
